





















import Vue from 'vue'
import UserForm from '@/apps/FNM/components/UserForm.vue'
import api from '@/api'
import { FNM_ROLES, SFD_ROLES } from '@/constants'

export default Vue.extend({
  components: {
    UserForm
  },

  data() {
    return {
      active: false,
      creating: false,
      roles: FNM_ROLES as any[],
      organizations: [] as any[],
      model: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        role: '',
        organizationId: ''
      }
    }
  },

  computed: {
    isSuperAdmin(): boolean {
      return this.$store.getters['auth/userRole'] === 'superadmin'
    }
  },

  mounted() {
    this.active = true
    if (this.isSuperAdmin) {
      this.fetchOrganizations()
    }
  },

  methods: {
    async fetchOrganizations() {
      try {
        const { data } = await api.get('/organizations', {
          params: { select: '-balances,-kkiapayAccounts' }
        })
        this.organizations = data || []
      } catch (err) {
        console.error(err) // eslint-disable-line
      }
    },

    onOrganizationChange(org: any) {
      this.roles = org.type === 'sfd' ? SFD_ROLES : FNM_ROLES
    },

    async onAdd(user: any) {
      this.creating = true
      try {
        await api.post('/users', user)
        this.creating = false
        this.active = false
        this.$notify.success("L'utilisateur a été ajouté avec succès !")
      } catch (error) {
        this.creating = false
        const err = error as any
        if (err.response && err.response.status === 400) {
          this.$notify.error("La création de l'utilisateur a échoué !")
          ;(this.$refs.form as any).setErrors(err.response.data.message)
        }
      }
    }
  }
})
